<template>
  <div class="page_candidate">
    <div
      class="candidate_info"
      v-if="mobiles.length > 0 && !isNull(resmue.msg)"
    >
      <div class="info_top flex">
        <div class="avatar" v-if="outInfo.external_contact.avatar">
          <img :src="outInfo.external_contact.avatar" alt="" />
        </div>
        <div class="portrait" v-else>头像</div>
        <div class="info_top_right">
          <div class="flex sb">
            <div class="candidate_name">
              {{ resmue.msg.StrUserName }} <span>@微信</span>
            </div>
            <div class="details_btn cp" @click="gotoResume">详情</div>
          </div>
          <div class="candidate_sex">
            <span v-if="resmue.msg.BolUserSex">{{
              resmue.msg.BolUserSex
            }}</span>
            <span v-if="resmue.msg.StrUsernation">{{
              resmue.msg.StrUsernation
            }}</span>
            <span v-if="resmue.msg.StrUserAge"
              >{{ resmue.msg.StrUserAge }}岁</span
            >
          </div>
        </div>
      </div>

      <div class="flex phone">
        <div>
          来源：{{ resmue.msg.StrSource ? resmue.msg.StrSource : "无" }}
        </div>
        <div style="margin-left: 40px">电话：{{ resmue.msg.StrMobile }}</div>
      </div>

      <div class="addtime">
        创建时间：{{
          resmue.msg.DtInsertDate
            ? resmue.msg.DtInsertDate.replace("T", " ")
            : "-"
        }}
      </div>

      <div class="flex addtime">
        <div>黑名单：{{ resmue.msg.StrIsBlack ? "是" : "否" }}</div>
        <!-- <div style="margin-left: 40px;">保护期至：2022/12/11</div> -->
      </div>

      <div class="divier"></div>

      <div v-if="resmue.msgonwork.length > 0">
        <div class="flex phone">
          <div>关联项目：{{ resmue.msgonwork[0].StrprojectName }}</div>
          <div class="status" style="margin-left: 40px">
            状态：{{ resmue.msgonwork[0].StrState }}
          </div>
        </div>

        <div class="phone">
          <div>关联岗位：{{ resmue.msgonwork[0].JobCategory }}</div>
        </div>
        <div class="phone">
          <div>
            更新时间：{{
              resmue.msgonwork[0].DtInserDate
                ? resmue.msgonwork[0].DtInserDate.replace("T", " ")
                : "-"
            }}
          </div>
        </div>
      </div>

      <div v-else>
        <div class="flex phone">
          <div>关联项目：无</div>
          <div class="status" style="margin-left: 40px">状态：无</div>
        </div>

        <div class="phone">
          <div>关联岗位：无</div>
        </div>
        <div class="phone">
          <div>更新时间：-</div>
        </div>
      </div>

      <div class="divier"></div>

      <div class="flex sb">
        <div class="title">标签</div>
        <div class="addbtn">
          <i
            class="el-icon-circle-plus-outline icon_add"
            @click="addLabel"
            title="更新标签"
          ></i>
        </div>
      </div>

      <div class="labelbox">
        <div class="tag" v-for="(item, index) in lPubDialogList" :key="index">
          {{ item.LableName }}
        </div>
        <div class="empty" v-if="lPubDialogList.length == 0">暂无标签</div>
      </div>

      <div class="divier"></div>

      <!-- <div class="flex sb">
        <div class="title">个人标签</div>
        <div class="addbtn">+添加</div>
      </div>

      <div class="labelbox">
        <div class="tag" v-for="(item,index) in labelList" :key="index">{{ item.name }}</div>
      </div>

      <div class="divier"></div> -->

      <div>
        <div class="title">服务流程</div>
      </div>

      <div class="serviceList">
        <div class="process" v-for="(item, index) in recordsList" :key="index">
          [{{ item.StrprojectName }}] {{ item.JobCategory }} -
          {{ item.StrState }}
          <span v-if="(item.StrState == '已报名')&&(!isNull(item.DtInserDate))">{{'(报名时间:'+item.DtInserDate+')'}}</span>
          <span v-if="(item.StrState == '约面')&&(!isNull(item.Dtappotime))">{{'(约面时间:'+item.Dtappotime+')'}}</span>
          <span v-if="(item.StrState == '通过')">
            <span v-if="!isNull(item.Dtreachtime)">{{'(预计到岗时间:'+item.Dtreachtime}}</span>
          </span>
          <span v-if="(item.StrState == '入职')&&(!isNull(item.Dtappotime))">{{'(入职时间:'+item.Dtappotime+')'}}</span>
          <span v-if="(item.StrState == '离职')&&(!isNull(item.Dtappotime))">{{'(离职时间:'+item.Dtappotime+')'}}</span>
          <span v-if="(item.StrState == '到面')&&(!isNull(item.Dtappotime))">{{'(到面时间:'+item.Dtappotime+')'}}</span>
           - {{ item.Username }} -
          {{ item.DtInserDate.replace("T", " ") }}
        </div>
        <div class="empty" v-if="recordsList.length == 0">暂无服务流程</div>
      </div>

      <div class="divier"></div>

      <div>
        <div class="title">跟进记录</div>

        <div class="serviceList">
          <div
            class="process"
            v-for="(item, index) in fowrecordsList"
            :key="index"
          >
            {{ item.StrUserJobhunt
            }}<span v-if="item.StrRemark">({{ item.StrRemark }})</span> -
            <span v-if="item.userName">({{ item.userName }})</span> -
            {{ item.DtInserDate.replace("T", " ") }}
          </div>
          <div class="empty" v-if="fowrecordsList.length == 0">
            暂无跟进记录
          </div>
        </div>
      </div>

      <div class="bottomBtnBox">
        <div class="bottomBtn" @click="followVisible = true">跟进</div>
        <!-- <el-popover placement="top" title="" width="150" trigger="manual" v-model="showCodeImg">
          <el-image style="width: 150px; height: 150px" :src="canvasImg" :preview-src-list=[canvasImg]>
          </el-image>
          <div class="bottomBtn" slot="reference" @click="showQcode">邀请填写简历</div>
        </el-popover> -->
        <div class="bottomBtn" @click="reflsh">刷新</div>
        <div class="bottomBtn" @click="gotoMatching" v-if="ResumeId">
          人岗匹配
        </div>
        <!-- <div class="bottomBtn" v-if="resmue.msg.StrPsnIsType!=1 || resmue.msg.StrPsnIsType!=3" @click="LaunchResumepublic">踢回公海</div> -->
      </div>
    </div>
    <div v-else-if="isNull(resmue.msg) && isover" class="noMobile">
      该客户暂无简历信息
      <div class="reflsh" @click="createResume">去填写简历</div>
    </div>
    <div v-else-if="noMobile" class="noMobile">
      请先给该客户备注手机号码
      <div class="reflsh" @click="reflsh">刷新</div>
    </div>

    <!-- 添加标签弹框 -->
    <el-dialog
      title="编辑标签"
      :visible.sync="addlabelVisible"
      width="90%"
      class="res_dialog"
    >
      <div class="r_label_box" v-loading="laloading">
        <div class="dia_label_box">
          <div
            class="dia_label_item"
            v-for="item in publicList"
            :key="item.LbGroup.Id"
          >
            <div class="dia_groupname">{{ item.LbGroup.LableName }}</div>
            <el-checkbox-group
              v-model="wholeCheckList"
              @change="dPubEnterHandle"
            >
              <el-checkbox
                v-for="(lab, index) in item.LbGroupVallist"
                border
                :label="lab.Id"
                :key="index"
              >
                <span v-if="lab.IsEnable">{{ lab.LableName }}</span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="flex">
          <div class="footerBtn leftbtn" @click="addlabelVisible = false">
            取消
          </div>
          <div class="footerBtn" @click="saveLabelHandle">确定</div>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      title="跟进"
      :visible.sync="followVisible"
      width="90%"
      class="res_dialog"
    >
      <div class="r_label_box">
        <div class="diaTitle">求职意向：</div>
        <van-radio-group v-model="followQuery.StrUserJobhunt">
          <van-radio name="有工作考虑新机会">有工作考虑新机会</van-radio>
          <van-radio name="在找工作">在找工作</van-radio>
          <van-radio name="不找工作">不找工作</van-radio>
          <van-radio name="未知">未知</van-radio>
        </van-radio-group>
        <div class="diaTitle">跟进内容：</div>
        <el-input
          v-model="followQuery.StrRemark"
          type="textarea"
          rows="3"
          size="small"
          clearable
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="flex">
          <div class="footerBtn leftbtn" @click="followVisible = false">
            取消
          </div>
          <div class="footerBtn" @click="confirmFollow">确定</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
    
<script>
import xz from "@/common";
import { fail } from "assert";
const wx = window.jWeixin;
export default {
  data() {
    return {
      signatureinfo: {},
      roletype: "",
      isreflsh: false,
      //外部联系人信息
      outInfo: "",
      //外部联系人手机号码
      mobiles: [],
      //没有备注手机号码
      noMobile: false,
      ResumeId: "",
      //简历信息
      resmue: {},
      //简历信息加载完成
      isover: false,
      includePublicChecks: [],
      //标签列表
      lPubDialogList: [],
      // 全局标签
      publicList: [],
      //打标签弹窗
      addlabelVisible: false,
      laloading: false,
      wholeCheckList: [],
      dCheckCommonLabelList: [],
      // 添加标签弹框选中的标签
      diaTagChecks: [],
      //跟进记录参数
      fowrecordsQuery: {
        resumeId: "",
        currpage: 1,
        perpage: 10,
      },
      //服务流程参数
      recordsQuery: {
        resumeId: "",
        roletype:'',
        currpage: 1,
        perpage: 10,
      },
      //流程记录
      recordsList: [],
      //流程总数
      recordsTotal: "",
      //跟进列表
      fowrecordsList: [],
      //跟进总数
      fowrecordsTotal: "",
      //跟进弹窗
      followVisible: false,
      followQuery: {
        ResumeId: "", // 简历id
        StrUserJobhunt: "", // 求职意愿
        StrReason: "", // 原因
        StrRemark: "", // 备注
        GduserId: "", // 操作人
        GduserName: "", // 操作人姓名
        StrOther: "", // 其他
        fCheckList: [],
      },
      //二维码路径
      canvasImg: "",
      showCodeImg: false,
    };
  },
  async created() {
    // this.$store.commit('setHiddenLeft', true);
  },
  mounted() {
    console.log("a", location.href.split("#")[0]);
    if (Cookies.get("userid-b") == undefined || !Cookies.get("userid-b")) {
      this.getWxUserInfo();
    } else {
      this.getOutWxUserInfo();
    }
    // this.getUserDetails()
    // this.getResumeDtl(18965265254)
  },
  methods: {
    //获取本人的登录信息
    getWxUserInfo() {
      var url = window.location.search; //获取url中"?"符后的字串
      let theRequest = new Object();
      // 判断是否有问号
      if (url.indexOf("?") != -1) {
        // 把问号去掉
        var str = url.substr(1);
        // 判断是否有多个参数
        if (str.indexOf("&") != -1) {
          // 以&符分项组成数组
          let strs = str.split("&");
          for (var i = 0; i < strs.length; i++) {
            // 循环数组
            // theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
            // 每一项等号左边为属性，等号右边为属性的值，值需要使用 decodeURI() 函数对通过 escape() 或 url 编码过的字符串进行解码。
            theRequest[strs[i].split("=")[0]] = decodeURI(
              strs[i].split("=")[1]
            );
          }
        } else {
          // 只有一个参数
          let arr = str.split("=");
          theRequest[arr[0]] = arr[1];
        }
      }
      if (theRequest.code != undefined) {
        console.log("code55");
        let getuserinfodata = {
          interface: {
            interfaceName: "getuserinfo",
            para: {
              appname: "QWAcctoken",
              state: theRequest.state,
              code: theRequest.code,
            },
          },
        };
        xz.getsignatureinfo(getuserinfodata).then((res) => {
          if (res.status == "ok") {
            Cookies.set("token", res.msg.token);
            let userinf = res.msg.userinf;
            xz.getuseridbymobile(userinf.mobile).then((res) => {
              console.log("ss", res.binf[0].GdUserId);
              let id = res.binf[0].GdUserId;
              Cookies.set("userid-b", id);
              Cookies.set("entid-b", id);
              this.getOutWxUserInfo();
              xz.getfollowuserc(userinf.userid).then((res) => {
                console.log(res);
              });
              this.getUserDetails();
            });
          } else {
            this.$toast.fail("获取用户信息出错");
          }
        });
      } else {
        // let head = location.origin.indexOf('localhost') > -1 ? 'https://dev.joball.net' : location.origin;
        let head = location.origin;
        let path = window.location.pathname;
        let qwcodeurldata = {
          interface: {
            interfaceName: "getqwcodeurl",
            para: {
              appname: "QWAcctoken",
              uri: head + path,
              state: "testaa",
            },
          },
        };
        xz.getqwcodeurl(qwcodeurldata).then((res) => {
          console.log("getqwcodeurl");
          console.log(res);
          window.location.href = res;
        });
      }
    },
    //获取外部联系人的信息
    getOutWxUserInfo() {
      let path = location.href.split("#")[0];
      let data = {
        interface: {
          interfaceName: "getsignatureinfo",
          para: {
            appname: "QWJsApiTicket4xjzj",
            url: path,
          },
        },
      };
      xz.getsignatureinfo(data).then((res) => {
        if (res.status == "ok") {
          let _that = this;
          wx.agentConfig({
            beta: true,
            debug: true,
            corpid: "ww643fa27d22a2ba87", // 必填，企业微信的corpid，必须与当前登录的企业一致
            agentid: "1000005", // 必填，企业微信的应用id
            timestamp: res.msg.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.msg.noncestr, // 必填，生成签名的随机串
            signature: res.msg.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
            jsApiList: ["getCurExternalContact"], //必填，传入需要使用的接口名称
            success: function (res) {
              //获取外部联系人的ID
              wx.invoke("getCurExternalContact", {}, function (res) {
                if (res.err_msg == "getCurExternalContact:ok") {
                  //返回当前外部联系人userId
                  let data = {
                    interface: {
                      interfaceName: "getcustinfo",
                      para: {
                        appname: "QWJsApiTicket4xjzj",
                        userid: res.userId,
                        cursor: "",
                      },
                    },
                  };
                  //获取外部联系人的手机号码等信息
                  xz.getsignatureinfo(data).then((res) => {
                    console.log("ppp", res, _that.outInfo);
                    if (res.errmsg == "ok") {
                      if (_that.isreflsh) {
                        _that.$toast.success("刷新成功");
                      }
                      _that.outInfo = res;
                      console.log("_that.outInfo2", _that.outInfo);
                      let mobiles = res.follow_user[0].remark_mobiles;
                      _that.mobiles = res.follow_user[0].remark_mobiles;
                      console.log("mobiles.length", mobiles);
                      if (mobiles.length > 0) {
                        _that.getResumeDtl(mobiles[0]);
                        _that.noMobile = false;
                      } else {
                        _that.noMobile = true;
                      }
                    } else {
                      _that.$toast.fail("获取外部联系人信息出错");
                    }
                  });
                  //   wx.invoke('openUserProfile', {
                  //     "type": 2, //1表示该userid是企业成员，2表示该userid是外部联系人
                  //     "userid": userId //可以是企业成员，也可以是外部联系人
                  //   }, function (res) {
                  //     if (res.err_msg != "openUserProfile:ok") {
                  //       //错误处理
                  //     } else {
                  //       console.log(res)
                  //     }
                  //   });
                } else {
                  //错误处理
                  _that.$toast.fail("获取外部联系人信息出错");
                  console.log("getCurExternalContactErr", res);
                }
              });
            },
            fail(res) {
              console.log("agentConfigErr", res);
              _that.$toast.fail("系统出错");
            },
          });
        }
      });
    },
    getUserDetails() {
      xz.getJbUserDetail(Cookies.get("userid-b")).then((res) => {
        if (res.status == "ok") {
          this.roletype = res.msgdep[0].Roletype;
          window.localStorage.setItem("loginRoletype", res.msgdep[0].Roletype);
          window.localStorage.setItem("gancode", res.msgdep[0].Strorgancode);
        }
      });
    },
    // 获取简历详情
    getResumeDtl(strMobile) {
      xz.getResumeDetail({ strMobile: strMobile }).then((res) => {
        if (res.status == "ok") {
          this.isover = true;
          this.resmue = res;
          this.ResumeId = res.msg.ResumeId;
          if (res.msg && res.msg.length != 0) {
            this.followQuery.ResumeId = res.msg.ResumeId;
            this.fowrecordsQuery.resumeId = res.msg.ResumeId;
            this.getresumelabelLists(res.msg.ResumeId);
            this.getstatusrecordsByresumeIdpro();
            this.getresumePsnfowrecords();

            console.log("ResumeId", res.msg.ResumeId);
          }
        } else {
          this.isover = true;
          Cookies.remove("userid-b");
          Cookies.remove("entid-b");
          Cookies.remove("token");
          this.$toast.fail("登录信息过期，请退出企微重新登录");
        }
      });
    },

    // 获取简历标签详情
    getresumelabelLists(resumeId) {
      this.includePublicChecks = [];
      xz.GetresumelabelLists({ resumeId: resumeId }).then((res) => {
        // console.log('getresumelabelLists', res)
        if (res.status == "ok") {
          this.lPubDialogList = res.msgpub;
        }
      });
    },
    addLabel() {
      // 全局标签
      for (let i = 0; i < this.lPubDialogList.length; i++) {
        const elementl1 = this.lPubDialogList[i];
        this.wholeCheckList.push(elementl1.LabelId);
      }
      this.addlabelVisible = true;
      this.GetLabelManagement();
    },
    //获取标签列表
    GetLabelManagement() {
      this.laloading = true;
      this.publicList = [];
      xz.GetLabelManagement(this.roleType).then((res) => {
        if (res.status == "ok") {
          this.publicList = res.data.PublicPersonList;
        }
        this.laloading = false;
      });
    },
    // 标签弹框 选择公有标签
    dPubEnterHandle(val) {
      this.dCheckCommonLabelList = [];
      // console.log('labelEnterHandle', val)
      this.dCheckCommonLabelList = val;
    },
    // 保存编辑标签
    saveLabelHandle() {
      this.diaTagChecks = this.dCheckCommonLabelList;
      //去重
      this.diaTagChecks = [...new Set(this.diaTagChecks)];
      let ids = this.diaTagChecks.toString();
      // console.log('uuu',this.resumeIds,this.diaTagChecks)
      if (this.isNull(this.diaTagChecks)) {
        this.$message({ type: "warning", message: "请选择标签" });
        return false;
      } else {
        this.tagHandle(
          { resumeIds: this.resmue.msg.ResumeId, labelIds: ids },
          "dialog"
        );
        // this.getList()
      }
    },
    // 打标签
    tagHandle(query, type) {
      // console.log('tagHandle', query)
      xz.savelabelResume(query).then((res) => {
        // console.log('tagHandle', res)
        if (res.status == "ok") {
          if (type == "dialog") {
            this.getresumelabelLists(query.resumeIds);
            this.addlabelVisible = false;
          }
          if (type == "enter") {
            this.enterResumeVisible = false;
          }
          this.$message({ type: "success", message: "操作成功" });
        } else {
          this.$message({ type: "error", message: "操作失败,请稍后再试" });
        }
      });
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN" ||
        o == "1900-01-01" ||
        o == "1900-01-01T00:00:00"
      );
    },
    //获取流程记录
    getstatusrecordsByresumeIdpro() {
      this.recordsQuery.resumeId = this.resmue.msg.ResumeId;
      this.recordsQuery.roletype = this.roletype;
      xz.getresumePsnstatusrecords(this.recordsQuery).then((res) => {
        if (res.status == "ok") {
          this.recordsList = res.msg;
          this.recordsTotal = res.totalcount;
        }
      });
    },
    //获取跟进记录
    getresumePsnfowrecords() {
      xz.getresumePsnfowrecords(this.fowrecordsQuery).then((res) => {
        if (res.status == "ok") {
          this.fowrecordsList = res.msg;
          this.fowrecordsTotal = res.totalcount;
        }
      });
    },
    confirmFollow() {
      if (!this.followQuery.StrUserJobhunt) {
        console.log(this.followQuery);
        this.$toast("请选择求职意向");
      } else {
        xz.savePsnfowrecords(this.followQuery).then((res) => {
          // console.log('saveEnterHandle', res)
          if (res.status == "ok") {
            this.getresumePsnfowrecords();
            this.$toast.success("保存成功");
          } else {
            this.$toast.fail("操作失败");
          }
          this.followVisible = false;
        });
      }
    },
    showQcode() {
      this.showCodeImg = !this.showCodeImg;
      if (this.showCodeImg) {
        this.getQcode();
      }
    },
    getQcode() {
      let data = {
        Id: "", // 岗位ID
        pagepath: "pages/enter/enter", // 页面URL
        strLinkType: "D", //A-报名二维码，B-到面二维码,C-入职二维码 D-简历采集二维(ID传空)
      };
      xz.getapplyjoobqrcodegenerated(localStorage.loginRoletype, data).then(
        (res) => {
          if (res.status == "ok") {
            let result = res.data;
            this.canvasImg = this.$store.state.EMP.imgPath + result;
          }
        }
      );
    },
    //踢回公海
    LaunchResumepublic() {
      xz.LaunchResumepublic({ resumeIds: this.resmue.msg.ResumeId }).then(
        (res) => {
          this.$toast({
            type: res.status == "ok" ? "success" : "fail",
            message: res.msg,
          });
          if (res.status == "ok") {
            this.getResumeDtl(this.outInfo.follow_user[0].remark_mobiles[0]);
          }
        }
      );
    },
    //查看简历详情
    gotoResume() {
      this.$router.push({
        path: "/resume",
        query: {
          mobiles: this.mobiles,
        },
      });
    },
    //创建简历
    createResume() {
      this.$router.push({
        path: "/editResume",
        query: {
          mobiles: this.mobiles[0],
        },
      });
    },
    //人岗匹配
    gotoMatching() {
      this.$router.push({
        path: "/matching",
        query: {
          ResumeId: this.ResumeId,
        },
      });
    },
    reflsh() {
      this.isreflsh = true;
      this.getOutWxUserInfo();
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN" ||
        o == "1900-01-01" ||
        o == "1900-01-01T00:00:00"
      );
    },
  },
};
</script>
 <style scoped>
html {
  font-size: 10px;
}

.navBar {
  height: 3.125rem;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 5px;
  border-bottom: 1px solid #fdfdfd;
}
.nav_Item {
  height: 24px;
  line-height: 24px;
  padding: 0 15px;
  background: #f2f2f2;
  margin-right: 10px;
}
.isActive {
  background: #19bd92;
  color: #fff;
}
.candidate_info {
  margin-top: 5px;
  font-size: 14px;
  padding: 10px;
  color: #333;
}
.info_top {
}
.portrait {
  width: 5rem;
  height: 5rem;
  text-align: center;
  line-height: 5rem;
  border: 1px solid #000;
  margin-right: 10px;
}
.avatar img {
  width: 5rem;
  height: 5rem;
  margin-right: 10px;
}
.info_top_right {
  width: 100%;
}
/* .candidate_name{
  width: 100%;
} */
.candidate_name span {
  color: #70b603;
}
.details_btn {
  color: #169bd5;
  margin-right: 20px;
}
.candidate_sex {
  margin-top: 10px;
}
.candidate_sex span {
  margin-right: 15px;
}
.phone {
  font-size: 14px;
  margin-top: 15px;
}
.addtime {
  margin-top: 10px;
  font-size: 14px;
}
.divier {
  border-bottom: 1px solid #7d7d7d;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 15px;
}
.status {
  font-size: 18px;
  font-weight: 600;
}
.title {
  font-size: 18px;
  font-weight: 600;
}
.addbtn {
  margin-right: 15px;
  font-size: 18px;
}
.labelbox {
  display: flex;
  direction: row;
  flex-wrap: wrap;
}
.tag {
  border: 1px solid #ddd;
  padding: 2px 3px;
  border-radius: 3px;
  height: auto;
  margin: 5px 20px 0 0;
  background: #fff;
}

.serviceList {
  margin-top: 15px;
}
.process {
  margin-top: 10px;
  font-size: 12px;
  color: #333;
}

.bottomBtnBox {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
}
.bottomBtn {
  height: 44px;
  /* line-height: 44px; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  text-align: center;
  font-size: 13px;
  background: #d7d7d7;
  word-wrap: break-word;
}
.dia_label_box .el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 0;
}
.dia_label_box .el-checkbox.is-bordered.is-checked,
.dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #19bd92;
}
.dia_label_box {
  max-height: 400px;
  overflow-y: auto;
}
.dia_label_box .dia_groupname {
  font-size: 14px;
  line-height: 25px;
  color: #333;
  font-weight: bold;
  margin-top: 5px;
  /* border-bottom: 1px solid #ddd; */
}
.dia_label_box .el-checkbox {
  border: 1px solid #ddd;
  padding: 2px 3px;
  border-radius: 3px;
  height: auto;
  margin: 5px 20px 0 0;
}
.diaTitle {
  font-size: 16px;
  margin-bottom: 10px;
}
.noMobile {
  padding-top: 100px;
  font-size: 16px;
  text-align: center;
  width: 100%;
}
.reflsh {
  padding: 10px;
  background: #19bd92;
  color: #fff;
  width: 60px;
  margin: 20px auto 0;
}
.empty {
  width: 100%;
  text-align: center;
  padding: 10px 0;
}
.footerBtn {
  width: 50%;
  text-align: center;
  border-top: 1px solid #f7f8f9;
  padding-top: 10px;
}
.leftbtn {
  border-right: 1px solid #f7f8f9;
}
</style>
    

<style>
.page_candidate .el-dialog__body {
  padding: 0 30px;
}
</style>
 